import {
  getCustomersApi,
  createCustomerApi,
  updateCustomerApi,
  deleteCustomerApi,
} from "../api/customers";
import { useAuth } from "./";

// Clientes: funciones que devuelven el resultado y dejan pasar el error (los
// formularios muestran los errores por campo que devuelve el backend).
export function useCustomer() {
  const { auth } = useAuth();
  const token = auth?.token;
  return {
    getCustomers: (search) => getCustomersApi(search, token),
    createCustomer: (data) => createCustomerApi(data, token),
    updateCustomer: (id, data) => updateCustomerApi(id, data, token),
    deleteCustomer: (id) => deleteCustomerApi(id, token),
  };
}
